export default __webpack_public_path__ + "static/media/mobile-app-homepage-mockup-2x.f5eb6daa.png";